<template>
  <div>
    <diy-tab title="主题游" type="tab" color="#9c27b0" active>
      <diy-tab-item name="first" label="全部">
        <div v-if="allGoodList.length == 0">
          <img src="./timg.png" style="width:800px;">
        </div>
        <good-list
          :goodList="allGoodList"
          v-loading="allLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        ></good-list>
      </diy-tab-item>
      <diy-tab-item name="second" label="云来客栈">
        <my-radio :option="yunlaiTypeRadio" v-model="yunlaiSelect"></my-radio>
        <div v-if="yunlaiGoodList.length == 0">
          <img src="./timg.png" style="width:800px;">
        </div>
        <good-list
          :goodList="yunlaiGoodList"
          v-loading="yunlaiLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        ></good-list>
      </diy-tab-item>
      <diy-tab-item name="three" label="御瀛庄">
        <my-radio :option="yuyinTypeRadio" v-model="yuyinSelect"></my-radio>
        <good-list
          :goodList="yuyinGoodList"
          v-loading="yuyinLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        ></good-list>
      </diy-tab-item>
      <diy-tab-item name="four" label="御泉府邸">
        <my-radio :option="yuquanTypeRadio" v-model="yuquanSelect"></my-radio>
        <good-list
          :goodList="yuquanGoodList"
          v-loading="yuquanLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        ></good-list>
      </diy-tab-item>
      <diy-tab-item name="five" label="门票">
        <div v-if="ticketGoodList.length == 0">
          <img src="./timg.png" style="width:800px;">
        </div>
        <good-list
          :goodList="ticketGoodList"
          v-loading="yuquanLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        ></good-list>
      </diy-tab-item>
      <!-- <diy-tab-item name="four" label="">Tab形式2</diy-tab-item> -->
    </diy-tab>
  </div>
</template>

<script>
import DiyTab from "@/components/DiyTab/index";
import DiyTabItem from "@/components/DiyTab/DiyTabItem";
import MyRadio from "@/components/MyRadio";
import GoodList from "./GoodList";
import {
  searchGoods,
  searchGoodsByType,
  searchAllGoodByStore
} from "@/api/good";
export default {
  components: {
    DiyTab,
    DiyTabItem,
    MyRadio,
    GoodList
  },
  data() {
    return {
      allGoodList: [],
      allLoading: false,
      yunlaiTypes: [],
      yunlaiSelect: 0,
      yunlaiGoodList: [],
      yunlaiLoading: false,
      yuyinTypes: [],
      yuyinSelect: 0,
      yuyinGoodList: [],
      yuyinLoading: false,
      yuquanTypes: [],
      yuquanSelect: 0,
      yuquanGoodList: [],
      yuquanLoading: false,
      ticketGoodList: []
    };
  },
  computed: {
    yunlaiTypeRadio() {
      return this.yunlaiTypes.map(e => {
        return e.name;
      });
    },
    yuyinTypeRadio() {
      return this.yuyinTypes.map(e => {
        return e.name;
      });
    },
    yuquanTypeRadio() {
      return this.yuquanTypes.map(e => {
        return e.name;
      });
    }
  },
  watch: {
    yunlaiSelect: {
      handler(value) {
        this.yunlaiLoading = true;
        let shop = this.yunlaiTypes[this.yunlaiSelect].shop_id;
        let id = this.yunlaiTypes[this.yunlaiSelect].id;
        searchGoodsByType(shop, id)
          .then(res => {
            this.yunlaiGoodList = res.data.goods;
          })
          .then(() => {
            this.yunlaiLoading = false;
          });
      }
    },
    yuyinSelect: {
      handler(value) {
        this.yuyinLoading = true;
        let shop = this.yuyinTypes[this.yuyinSelect].shop_id;
        let id = this.yuyinTypes[this.yuyinSelect].id;
        searchGoodsByType(shop, id)
          .then(res => {
            this.yuyinGoodList = res.data.goods;
          })
          .then(() => {
            this.yuyinLoading = false;
          });
      }
    },
    yuquanSelect: {
      handler(value) {
        this.yuquanLoading = true;
        let shop = this.yuquanTypes[this.yuquanSelect].shop_id;
        let id = this.yuquanTypes[this.yuquanSelect].id;
        searchGoodsByType(shop, id)
          .then(res => {
            this.yuquanGoodList = res.data.goods;
          })
          .then(() => {
            this.yuquanLoading = false;
          });
      }
    }
  },
  created() {
    this.allGood();
    this.yunlaiGood();
    this.yuyinGood();
    this.yuquanGood();
    this.ticketGood();
  },
  methods: {
    allGood() {
      const store_no = 49;
      this.allLoading = true;
      searchAllGoodByStore(store_no)
        .then(res => {
          this.allGoodList = res.data.goods;
        })
        .then(() => {
          this.allLoading = false;
        });
    },
    yunlaiGood() {
      const store_no = 49;
      const type = 2;
      searchGoods(store_no, type)
        .then(res => {
          res.data.type.forEach(element => {
            if(element.name!='一人入格'){
              this.yunlaiTypes.push(element)
            }
          });
        })
        .then(() => {
          this.yunlaiLoading = true;
          let shop = this.yunlaiTypes[this.yunlaiSelect].shop_id;
          let id = this.yunlaiTypes[this.yunlaiSelect].id;
          searchGoodsByType(shop, id)
            .then(res => {
              
              this.yunlaiGoodList = res.data.goods;
            })
            .then(() => {
              this.yunlaiLoading = false;
            });
        });
    },
    yuyinGood() {
      const store_no = 50;
      const type = 2;
      searchGoods(store_no, type)
        .then(res => {
          this.yuyinTypes = res.data.type;
        })
        .then(res => {
          this.yuyinLoading = true;
          let shop = this.yuyinTypes[this.yuyinSelect].shop_id;
          let id = this.yuyinTypes[this.yuyinSelect].id;
          searchGoodsByType(shop, id)
            .then(res => {
              this.yuyinGoodList = res.data.goods;
            })
            .then(() => {
              this.yuyinLoading = false;
            });
        });
    },
    yuquanGood() {
      const store_no = 51;
      const type = 2;
      searchGoods(store_no, type)
        .then(res => {
          this.yuquanTypes = res.data.type;
        })
        .then(res => {
          this.yuquanLoading = true;
          let shop = this.yuquanTypes[this.yuquanSelect].shop_id;
          let id = this.yuquanTypes[this.yuquanSelect].id;
          searchGoodsByType(shop, id)
            .then(res => {
              this.yuquanGoodList = res.data.goods;
            })
            .then(() => {
              this.yuquanLoading = false;
            });
        });
    },
    ticketGood() {
      const store_no = 52;
      const type = 3;
      let ticketGoodList =[]
      searchGoodsByType(store_no, type)
        .then(res => {
          ticketGoodList = res.data.goods;
          console.log(res);
        })
        .then(() => {
          searchGoodsByType(122, type)
            .then(res => {
              
              this.ticketGoodList = ticketGoodList.concat(res.data.goods);
              console.log(res);
            })
            .then(() => {
              this.yuquanLoading = false;
            });
        });
    }
  }
};
</script>

<style>
</style>
